export default {
  methods: {
    getUserAgent: function getUserAgent() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        this.platform = '';
      } else if (/android/i.test(userAgent)) {
        this.platform = 'Android';
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.platform = 'App Store';
      }
    }
  }
};